import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ReminderTypeEnum } from '@zaoblako/shared/modules/notification/enums/reminder.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link ReminderTypeEnum} enumeration values */
export const ReminderTypeEnumI18n: EnumI18nInterface<ReminderTypeEnum> = {
  [I18nLocalesEnum.EN_US]: {
    [ReminderTypeEnum.PROJECT]: 'Project reminder',
    [ReminderTypeEnum.PROJECT_CHECKLIST]: 'Project checklist reminder',
    [ReminderTypeEnum.DEAL]: 'Deal reminder',
    [ReminderTypeEnum.DEAL_EVENT]: 'Deal event reminder',
    [ReminderTypeEnum.HELPDESK]: 'HelpDesk task reminder',
    [ReminderTypeEnum.DEBT_COLLECTION_TASK]: 'Debt collection task personal reminder',
    [ReminderTypeEnum.DEBT_COLLECTION_TASK_EVENT]: 'Debt collection task event reminder for event responsible',
  },
  [I18nLocalesEnum.RU_RU]: {
    [ReminderTypeEnum.PROJECT]: 'Напоминание по задаче',
    [ReminderTypeEnum.PROJECT_CHECKLIST]: 'Напоминание по событию задачи',
    [ReminderTypeEnum.DEAL]: 'Напоминание по сделке',
    [ReminderTypeEnum.DEAL_EVENT]: 'Напоминание по событию сделки',
    [ReminderTypeEnum.HELPDESK]: 'Напоминание по заявке HelpDesk',
    [ReminderTypeEnum.DEBT_COLLECTION_TASK]: 'Напоминание по заявке на взыскание долга',
    [ReminderTypeEnum.DEBT_COLLECTION_TASK_EVENT]: 'Напоминание по событию заявки на взыскание долга',
  },
};
